import { Controller } from "@hotwired/stimulus"

// Explication d'un terme, derrière un « i » à côté de la question.
//
// Ce n'est délibérément pas un attribut `title` ni une info-bulle au survol :
// l'outil se remplit sur tablette, où le survol n'existe pas, et où `title`
// n'est atteignable ni au doigt ni au clavier. C'est donc un bouton — il
// s'ouvre au clic comme à la tabulation, et se ferme à Échap.
//
// Le survol reste pris en charge sur les pointeurs qui en ont un, parce qu'au
// bureau on veut lire l'explication sans casser sa frappe. Mais il ouvre le
// même panneau que le clic : un seul état, une seule façon de le fermer.
export default class extends Controller {
  static targets = ["button", "note"]

  connect() {
    this.pointerFine = window.matchMedia("(hover: hover)").matches
  }

  toggle() {
    this.noteTarget.hidden ? this.open() : this.close()
  }

  // Le survol n'ouvre que sur un pointeur précis. Sur un écran tactile, le
  // navigateur émule un survol au toucher : sans ce garde, un doigt
  // ouvrirait puis refermerait aussitôt le panneau.
  show() {
    if (this.pointerFine) this.open()
  }

  hide() {
    if (this.pointerFine) this.close()
  }

  open() {
    this.noteTarget.hidden = false
    this.buttonTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.noteTarget.hidden = true
    this.buttonTarget.setAttribute("aria-expanded", "false")
  }
}
